export class ReporteViaje {

public // public title: string: string;
public  idCompania: string;
public  idUsuario: string;
public  nombreUsuario: string;
public  idVehiculo: string;
public  idPunto: string;
public  nombrePunto: string;
public  idViaje: string;
public  idVisita: string;
public  numeroGuia: string;
public  fechaAsignacion: Date;
public  totalPendientes: number;
public  totalAbortados: number;
public  totalVisitados: number;
public contadorPuntosDeVisita:number;
}